export const DISABLE_SAVE = 'DISABLE_SAVE';
export const ENABLE_SAVE = 'ENABLE_SAVE';
export const SET_LANDING_PAGE_SNIPPET = 'SET_LANDING_PAGE_SNIPPET';
